import React from 'react'
import { Box, Button, Card, CardContent, Typography } from '@mui/material'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'

import { useFechInitForm } from './hooks'

import {
    DateChangeSection,
    DepositRefundSection,
    ExtensionOfTermSection,
    BalanceInformationSection
} from './Sections'
import { 
    FieldContract,
    InfoContract,
    FieldManagementType,
    ApprovalManagement,
    ObservationsContract
} from './Common'
import { ModalModule } from './ModalModule'

export const LegalFormLeasesManagements = () => {


    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFechInitForm({location, paramsURL})

    const {
        globalStates,
        FetchData,
        Forms,
        Helpers,
        defaultData,
        //------------- Actions
        Actions
    } = useFetchInit

    const { identifySelectedRequestType } = Helpers

    const { FormRequestGlobal } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormRequestGlobal

    const { handleClickCloseForm, onSubmitFormRequests, onSendLogs, handleChangeContract } = Actions

    const { fetchAllTypeManagements, fetchInfoObservations } = FetchData
    const { typeManagements } = fetchAllTypeManagements
    const { observations } = fetchInfoObservations

    const {formOpeningMode, showFormContract} = globalStates

    return (
        <AllowedAccess permissions={['116_ARRENDAMIENTOS_GESTIONES']} renderAuthFailed={<p>Error</p>}>
            <ModalModule useFetchInit={useFetchInit} />
            <div className="content">
                <div className='panel-body'>
                    <form onSubmit={onSubmitFormRequests}>
                        <Card style={{zIndex:'1'}}>
                            <CardContent>
                                <Typography sx={{color:'warning.main'}} variant='overline' >
                                * campos obligatorios
                                </Typography>

                                <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                                    Informacion sobre el contrato
                                </Typography>
                                <div className="border-bottom border-dark"></div>
                                <FieldContract
                                    formState={formState}
                                    handleChangeContract={handleChangeContract}
                                    FetchData={FetchData}
                                    readOnly={(formOpeningMode==='READONLY') ? true: false}
                                />
                                {showFormContract && (
                                    <InfoContract 
                                        formState={formState}
                                        FetchData={FetchData}
                                    />
                                )}

                                <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                                    Informacion sobre la gestion
                                </Typography>
                                <div className="border-bottom border-dark"></div>
                                <FieldManagementType
                                    formState={formState}
                                    onSelectSearchChange={onSelectSearchChange}
                                    FetchData={FetchData}
                                    readOnly={(formOpeningMode==='READONLY') ? true: false}
                                />
            
                                {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'CFP' && (
                                    <>
                                        <DateChangeSection useFetchInit={useFetchInit} />
                                    </>
                                )}
            
                                {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'DDP' && (
                                    <>
                                        <DepositRefundSection useFetchInit={useFetchInit} />
                                    </>
                                )}
                                
                                {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'ADP' && (
                                    <>
                                        <ExtensionOfTermSection useFetchInit={useFetchInit} />
                                    </>
                                )}
                                
                                {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'CJD' && (
                                    <>
                                        <BalanceInformationSection useFetchInit={useFetchInit} />
                                    </>
                                )}
                                
                                {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'FEJ' && (
                                    <>
                                        <BalanceInformationSection useFetchInit={useFetchInit} />
                                    </>
                                )}
                                
                                {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'FJD' && (
                                    <>
                                        <BalanceInformationSection useFetchInit={useFetchInit} />
                                    </>
                                )}
                                
                                {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'ECI' && (
                                    <>
                                        <BalanceInformationSection useFetchInit={useFetchInit} />
                                    </>
                                )}
            
                                {(formOpeningMode==='READONLY') && (
                                    <>
                                        <ApprovalManagement
                                        formState={formState}
                                        optionsAprobacionCheck={defaultData.optionsAprobacionCheck}
                                        />
                
                                    </>
                                )} 
            
                                {(formState.idgestion>0) && (
                                    <ObservationsContract
                                        formState={formState}
                                        onInputChange={onInputChange}
                                        onSendLogs={onSendLogs}
                                        observations={observations}
                                    />
                                )}
            
                                {identifySelectedRequestType(typeManagements, formState.idgestiontipo) !== 'ADP' && (
                                    <Box className="text-center" sx={{mt: 2}}>
                                        {(formOpeningMode==='EDITABLE') && (
                                            <Button
                                                style={{background: "#4b4b4c"}}
                                                variant="contained"
                                                type='submit'
                                            >
                                                <i className="fa-regular fa-floppy-disk"></i> &nbsp; Enviar Gestion
                                            </Button>
                                        )} 
                                        &nbsp; &nbsp;
                                        <Button 
                                            style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                            type="button" 
                                            variant="contained"
                                            onClick={handleClickCloseForm} 
                                            sx={{ marginRight: 1, marginLeft: 1 }}
                                        >
                                            <i className="fa-regular fa-circle-left"></i> &nbsp; Volver
                                        </Button>
                                    </Box>
                                )}
            
                                
                            </CardContent>
                        </Card>
                    </form>
                </div>
            </div>
        </AllowedAccess>
    )
}
